exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!../colours.icss"), undefined);

// module
exports.push([module.id, ".ExpandableSection__expansionPanel___3_HoJ {\n\tbox-shadow: inherit!important;\n}\n\n.ExpandableSection__expansionSummary___1wY6Z {\n\tpadding-left: " + require("-!../../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!../colours.icss").locals["pagePadding"] + "!important;\n\tborder-bottom: 1px solid #ddd!important;\n}\n\n.ExpandableSection__expansionDetails___15ALJ {\n\tpadding: 0!important;\n\tflex-direction: column;\n}\n\n.ExpandableSection__expandIcon___3yFWN {\n\tright: 0!important;\n}\n", ""]);

// exports
exports.locals = {
	"pagePadding": "" + require("-!../../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!../colours.icss").locals["pagePadding"] + "",
	"mainTextColour": "" + require("-!../../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!../colours.icss").locals["mainTextColour"] + "",
	"inverseMainTextColour": "" + require("-!../../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!../colours.icss").locals["inverseMainTextColour"] + "",
	"expansionPanel": "ExpandableSection__expansionPanel___3_HoJ",
	"expansionSummary": "ExpandableSection__expansionSummary___1wY6Z",
	"expansionDetails": "ExpandableSection__expansionDetails___15ALJ",
	"expandIcon": "ExpandableSection__expandIcon___3yFWN"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/ExpandableSection.icss
// module id = 1332
// module chunks = 0